// 顶岗实习
import Internship from "@/components/newPages/student/internship/index"
import Jobs from "@/components/newPages/student/internship/jobs"
import addJobs from "@/components/newPages/student/internship/addJobs"
import Changes from "@/components/newPages/student/internship/changes"
import Attendance from "@/components/newPages/student/internship/attendance"
import Plan from "@/components/newPages/student/internship/plan"
import planList from "@/components/newPages/student/internship/planList"
import ApplyFor from "@/components/newPages/student/internship/applyFor"
import ApplyStatus from "@/components/newPages/student/internship/applyStatus"
import ExemptionApplication from "@/components/newPages/student/internship/exemptionApplication"
import Statistics from "@/components/newPages/student/internship/statistics"
import Replacement from "@/components/newPages/student/internship/replacement"
import FreeSignList from "@/components/newPages/student/internship/freeSignList"
import AskLevelList from "@/components/newPages/student/internship/askLevelList"
import Daily from "@/components/newPages/student/internship/daily"
import Weekly from "@/components/newPages/student/internship/weekly"
import Monthly from "@/components/newPages/student/internship/monthly"
import Summary from "@/components/newPages/student/internship/summary"
import SummaryDetail from "@/components/newPages/student/internship/summaryDetail"
import SummaryList from "@/components/newPages/student/internship/summaryList"
import Dsfxylist from "@/components/newPages/student/internship/dsfxy_list"
import Dsfxysc from "@/components/newPages/student/internship/dsfxy_sc"
import Bxsc from "@/components/newPages/student/internship/bxsc"
import Jzzqslist from "@/components/newPages/student/internship/jzzqs_list"
import JzzqsSc from "@/components/newPages/student/internship/jzzqs_sc"
import Achievement from "@/components/newPages/student/internship/achievement"
import UniChange from "@/components/newPages/student/internship/uniChange"
import DisperseChange from "@/components/newPages/student/internship/disperseChange"
import Done from "@/components/newPages/student/internship/done"
const internship = [
    // 顶岗实习
    {
        path: "/internship/index",
        name: "internship",
        component: Internship,
    },
    {
        path: "/internship/jobs",
        name: "Jobs",
        component: Jobs
    },
    {
        path: "/internship/addJobs",
        name: "addJobs",
        component: addJobs
    },
    {
        path: "/internship/changes",
        name: "Changes",
        component: Changes
    },
    {
        path: "/internship/attendance",
        name: "Attendance",
        component: Attendance
    },
    {
        path: "/internship/plan",
        name: "Plan",
        component: Plan
    },
    {
        path: "/internship/planList",
        name: "PlanList",
        component: planList
    },
    {
        path: "/internship/applyStatus",
        name: "ApplyStatus",
        component: ApplyStatus
    },
    {
        path: "/internship/applyFor",
        name: "ApplyFor",
        component: ApplyFor
    },
    {
        path: "/internship/exemptionApplication",
        name: "ExemptionApplication",
        component: ExemptionApplication
    },
    {
        path: "/internship/statistics",
        name: "Statistics",
        component: Statistics
    },
    {
        path: "/internship/replacement",
        name: "Replacement",
        component: Replacement
    },
    {
        path: "/internship/freeSignList",
        name: "FreeSignList",
        component: FreeSignList
    },
    {
        path: "/internship/askLevelList",
        name: "AskLevelList",
        component: AskLevelList
    },
    {
        path: "/internship/daily",
        name: "Daily",
        component: Daily
    },
    {
        path: "/internship/weekly",
        name: "Weekly",
        component: Weekly
    },
    {
        path: "/internship/monthly",
        name: "Monthly",
        component: Monthly
    },
    {
        path: "/internship/summary",
        name: "Summary",
        component: Summary
    },
    {
        path: "/internship/summaryDetail",
        name: "SummaryDetail",
        component: SummaryDetail
    },
    {
        path: "/internship/summaryList",
        name: "SummaryList",
        component: SummaryList
    },
    {
        path: "/internship/dsfxylist",
        name: "Dsfxylist",
        component: Dsfxylist
    },
    {
        path: "/internship/dsfxysc",
        name: "Dsfxysc",
        component: Dsfxysc
    },
    {
        path: "/internship/bxsc",
        name: "Bxsc",
        component: Bxsc
    },
    {
        path: "/internship/jzzqslist",
        name: "Jzzqslist",
        component: Jzzqslist
    },
    {
        path: "/internship/jzzqs_sc",
        name: "JzzqsSc",
        component: JzzqsSc
    },
    {
        path: "/internship/achievement",
        name: "Achievement",
        component: Achievement
    },
    {
        path: "/internship/uniChange",
        name: "UniChange",
        component: UniChange
    },
    {
        path: "/internship/disperseChange",
        name: "DisperseChange",
        component: DisperseChange
    },
    {
        path: "/internship/done",
        name: "Done",
        component: Done
    },
    // 教师端
    {
        path: "/internshipTeacher/index",
        name: "InternshipTeacher",
        component: () =>
            import ('@/components/newPages/teacher/internship/index')
    },
    {
        path: "/internshipTeacher/index_detal",
        name: "InternshipTeacherDetal",
        component: () =>
            import ('@/components/newPages/teacher/internship/index_detal')
    },
    {
        path: "/internshipTeacher/studentDetail",
        name: "StudentDetail",
        component: () =>
            import ('@/components/newPages/teacher/internship/studentDetail')
    },
    {
        path: "/internshipTeacher/myStudent",
        name: "MyStudent",
        component: () =>
            import ('@/components/newPages/teacher/internship/myStudent')
    },
    {
        path: "/internshipTeacher/gxTjDetal",
        name: "gxTjDetal",
        component: () =>
            import ('@/components/newPages/teacher/internship/gxTjDetal')
    },
    {
        path: "/internshipTeacher/approvalList",
        name: "ApprovalList",
        component: () =>
            import ('@/components/newPages/teacher/internship/approvalList')
    },
    {
        path: "/internshipTeacher/applyStatus",
        name: "ApplyStatus",
        component: () =>
            import ('@/components/newPages/teacher/internship/applyStatus')
    },
    {
        path: "/internshipTeacher/statistics",
        name: "TeacherStatistics",
        component: () =>
            import ('@/components/newPages/teacher/internship/statistics')
    },
    {
        path: "/internshipTeacher/guideList",
        name: "GuideList",
        component: () =>
            import ('@/components/newPages/teacher/internship/guideList')
    },
    {
        path: "/internshipTeacher/guideStudent",
        name: "GuideStudent",
        component: () =>
            import ('@/components/newPages/teacher/internship/guideStudent')
    },
    {
        path: "/internshipTeacher/guideDetail",
        name: "GuideDetail",
        component: () =>
            import ('@/components/newPages/teacher/internship/guideDetail')
    },
    {
        path: "/internshipTeacher/summaryList",
        name: "SummaryList",
        component: () =>
            import ('@/components/newPages/teacher/internship/summaryList')
    },
    {
        path: "/internshipTeacher/newGuide",
        name: "NewGuide",
        component: () =>
            import ('@/components/newPages/teacher/internship/newGuide')
    },
    {
        path: "/internshipTeacher/studentList",
        name: "StudentList",
        component: () =>
            import ('@/components/newPages/teacher/internship/studentList')
    },
    {
        path: "/internshipTeacher/summaryDetail",
        name: "SummaryDetail",
        component: () =>
            import ('@/components/newPages/teacher/internship/summaryDetail')
    },
    {
        path: "/internshipTeacher/statisticsTypeList",
        name: "StatisticsTypeList",
        component: () =>
            import ('@/components/newPages/teacher/internship/statisticsTypeList')
    },
    {
        path: "/internshipTeacher/attendanceDetail",
        name: "AttendanceDetail",
        component: () =>
            import ('@/components/newPages/teacher/internship/attendanceDetail')
    },
    {
        path: "/internshipTeacher/attendanceStatiscs",
        name: "AttendanceStatiscs",
        component: () =>
            import ('@/components/newPages/teacher/internship/attendanceStatiscs')
    },
    {
        path: "/internshipTeacher/monthlyList",
        name: "TeacherMonthlyList",
        component: () =>
            import ('@/components/newPages/teacher/internship/monthlyList')
    },
    {
        path: "/internshipTeacher/monthly",
        name: "TeacherMonthly",
        component: () =>
            import ('@/components/newPages/teacher/internship/monthly')
    },
    {
        path: "/internshipTeacher/weekList",
        name: "TeacherWeekList",
        component: () =>
            import ('@/components/newPages/teacher/internship/weekList')
    },
    {
        path: "/internshipTeacher/weekly",
        name: "TeacherWeekly",
        component: () =>
            import ('@/components/newPages/teacher/internship/weekly')
    },
    {
        path: "/internshipTeacher/dayList",
        name: "TeacherDayList",
        component: () =>
            import ('@/components/newPages/teacher/internship/dayList')
    },
    {
        path: "/internshipTeacher/dayly",
        name: "TeacherDayLy",
        component: () =>
            import ('@/components/newPages/teacher/internship/dayly')
    },


]
export default internship


// WEBPACK FOOTER //
// ./src/router/internship.js